import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DataManipService } from './Services/data-manip.service';

// import 'css-doodle';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: `<router-outlet></router-outlet> 
  <button id="removebackdropofrezzarpay" style="display:none"></button>`
})
export class AppComponent implements OnInit {
  constructor(private dataManipSrvc:DataManipService,private router: Router) { 
    const user = localStorage.getItem("userdata");
    if(user){
      this.dataManipSrvc = JSON.parse(user);
      // console.log('set user',this.dataManipSrvc,user);
      
    }
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  

  }



  // trigger-variable for Ladda
  isLoading: boolean = false;

  toggleLoading() {
    this.isLoading = !this.isLoading;
  }
}
    
